import slice from "./adminsSlice";

export default slice.reducer;
